// removed by extract-text-webpack-plugin
module.exports = {"ascending":"selectionTable__ascending__1vr6B","descending":"selectionTable__descending__2UgVu"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Monitoring/selectionTable.css
// module id = 1693
// module chunks = 2